import React, { useState } from 'react'
import Box from '@mui/joy/Box/index.js'
import Sheet from '@mui/joy/Sheet/index.js'
import Tabs from '@mui/joy/Tabs/index.js'
import TabList from '@mui/joy/TabList/index.js'
import Tab from '@mui/joy/Tab/index.js'
import TabPanel from '@mui/joy/TabPanel/index.js'
import Typography from '@mui/joy/Typography/index.js'
import ConversationReview from './ConversationReview.jsx'
import Statistics from './Statistics.jsx'
import LLMRatingAnalysis from './LLMRatingAnalysis.jsx'

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
      }}
    >
      <Sheet
        sx={{
          p: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.surface',
        }}
      >
        <Typography level="h3">Admin Control Panel</Typography>
      </Sheet>

      <Tabs
        value={activeTab}
        onChange={(event, newValue) => {
          setActiveTab(newValue)
        }}
        sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
      >
        <TabList sx={{ px: 2, pt: 2 }}>
          <Tab>Conversation Review</Tab>
          <Tab>LLM Rating Analysis</Tab>
          <Tab>Statistics</Tab>
        </TabList>

        <TabPanel value={0} sx={{ flex: 1, overflow: 'hidden', p: 0 }}>
          <ConversationReview />
        </TabPanel>

        <TabPanel value={1} sx={{ flex: 1, overflow: 'hidden', p: 0 }}>
          <LLMRatingAnalysis />
        </TabPanel>

        <TabPanel value={2} sx={{ flex: 1, overflow: 'hidden', p: 0 }}>
          <Statistics />
        </TabPanel>
      </Tabs>
    </Box>
  )
}
